import React from 'react'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import IconButton from '@mui/material/IconButton'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputAdornment from '@mui/material/InputAdornment'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

export type InputPasswordProps = {
  fullWidth?: boolean
  onChange?: (data: string) => void
  defaultValue?: string
  value?: string
  name?: string
  error?: boolean
  helperText?: string
}

const InputPassword: React.FC<InputPasswordProps> = ({
  fullWidth,
  onChange,
  defaultValue,
  value,
  name,
  error,
  helperText,
}: InputPasswordProps) => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event.target.value)
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }

  return (
    <FormControl error={error} fullWidth={fullWidth}>
      <OutlinedInput
        name={name}
        type={showPassword ? 'text' : 'password'}
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="large">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default InputPassword
